export default __webpack_public_path__ + "static/2024-img-articolo-dicembre2-1-fd59cd01c99f3143c4b7744b70308c17.jpg";